export function initTranslationFields({locales, fields, translation = null})
{
    let data = []

    if(translation){
      data = getLocaleFields(translation, fields)
    }

    return initLocaleFields(locales, fields, data)
}

function initLocaleFields(locales, fields, data){
    let resp = {}
    locales.map((item)=>{
        fields.map((field)=>{
            resp[item] = {
                ...resp[item],
                [field]: data[item] ? (data[item][field] ? data[item][field] : '') : '',
            }
        })
    })
    return resp
}

function getLocaleFields(translations, fields){
    let resp = []
    translations.map((item)=>{
        fields.map((field)=>{
            resp[item.locale] = {
                ...resp[item.locale],
                [field]: item[field],
            }
        })
    })
    return resp
}

export function initTranslationFieldsV2(translations)
{
    let resp = {}
    if (translations.length > 0 ) {
        translations.map((item)=>{
            resp[item.locale] = {
                ...item,
            }
        })
    }

    return resp
}